<template>
  <div>
    <!-- Верхняя часть -->
    <div class="d-flex justify-space-between align-center mb-0">
      <div class="text-subtitle-2 grey--text">Дата действия:<a-view-datetime :value="data.createdon" /></div>
    </div>
    <!-- Описание -->
    <div class="text-body-1 mb-4">
      <div v-if="task_template.name" class="text-subtitle-2">Задача: {{ task_template.name }}</div>
      <div v-if="data?.data && data.data.result" class="text-subtitle-2">Результат: {{ action_text }}</div>
      <div class="text-subtitle-2 d-flex align-center">
        <div>{{ data.comment }} {{ task_template.description }}</div>
        <div v-if="data.data && data.data.link" class="d-flex align-center">
          <a-view-table-record :model="{ direct: true }" :value="data.data.link" style="line-height: 0; padding-left: 15px" />
          <v-btn
            v-if="data.data && !(data.data.analysisResult && data.data.analysisResult.summary) && getAccess('leads.callAnalysis')"
            :loading="analyzing"
            :disabled="analyzing"
            color="blue-grey"
            class="ml-2 white--text"
            @click="doAnalyze(data)"
            small
          >
            Анализ
            <v-icon right dark> fas fa-flask </v-icon>
          </v-btn>
          <v-btn
            v-if="data.data && data.data.analysisResult && getAccess('leads.callAnalysis') && data.data.analysisResult.summary"
            color="blue-grey"
            class="ml-2 white--text"
            @click="$emit('call-info', data.data.analysisResult, 1)"
            small
          >
            <v-icon dark> far fa-chart-bar </v-icon>
          </v-btn>
          <v-btn
            v-if="data.data && data.data.analysisResult && getAccess('leads.callAnalysis') && data.data.analysisResult.textFromAudio"
            color="blue-grey"
            class="ml-2 white--text"
            @click="$emit('call-info', data.data.analysisResult, 2)"
            small
          >
            <v-icon dark> far fa-comments </v-icon>
          </v-btn>
        </div>
      </div>
      <div v-if="data.data && data.data.analysisResult && data.data.analysisResult.summary" class="text-body-2 mt-3">{{ data.data.analysisResult.summary }}</div>
    </div>
  </div>
</template>

<script>
import { getAccess, popupMenu, genModel } from "@/components/mixings";
export default {
  mixins: [getAccess, popupMenu, genModel],
  components: {},
  props: {
    data: Object,
  },
  data() {
    return {
      task_template: {},
      results: [],
      analyzing: false,
    };
  },
  async created() {
    //await this.fetchTaskData();
  },
  computed: {
    action_text() {
      return this.data.data.result;
    },
    checkBtn() {
      return this.result?.status !== "done";
    },
    results_() {
      let res = this.data?.leads_task_template_data?.results || [];

      return res;
    },
  },
  methods: {
    async fetchTaskData() {
      let api = "/mechti/leads_task_template";
      let id;
      id = this.data?.type;
      if (!id) return;
      let r = await this.$axios.get(api + "/" + id);
      for (const name in r.data.data) {
        this.$set(this.task_template, name, r.data.data[name]);
      }
      this.results = [...(r.data.data.data?.results?.results || [])];
    },
    async doAnalyze(data) {
      let api = "/mechti/leads_action/records/analysis";
      let id;
      id = data.id;
      if (!id) return;
      this.analyzing = true;
      let r = await this.$axios.get(api + "/" + id);
      //this.analyzing = false;
    },
  },
};
</script>

<style scoped>
.amo-card {
  border-radius: 12px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
  transition: box-shadow 0.3s ease;
}
.amo-card:hover {
  box-shadow: 0 5px 14px rgba(0, 0, 0, 0.15);
}
</style>
